export default __webpack_public_path__ + "static/media/dropdown_blue.63368c4a.svg";